<template>
  <div class="apply-wrapper">
    <a-row class="header-wrapper" type="flex" justify="center" align="middle">
      <a-col :span="20" class="header-content">
        <div class="flex-a-c">
          <img
            :src="Logo"
            alt="logo"
            width="54"
            height="54"
            style="margin-right: 20px"
          />
          <div class="title flex-a-c">{{ title }}</div>
        </div>
        <div class="user-info flex-a-c">
          <a-dropdown>
            <div class="pointer header-menu flex-a-c">
              <div>
                <a-avatar :src="headImg" />
              </div>
              <div class="name ellipsis">{{ userName }}</div>
            </div>

            <a-menu slot="overlay" @click="handleClick">
              <!-- <a-menu-divider /> -->
              <a-menu-item key="logout"> 退出登录 </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-col>
    </a-row>
    <a-row
      type="flex"
      justify="center"
      style="padding: 20px; background: #f5f5fc"
    >
      <a-col :span="20">
        <h2 class="bold textalign-c">认证个人信息</h2>
        <div class="user-info">
          <!-- <div class="m-t-10 m-b-24 attestation bold" style="margin-bottom:24px">
        认证信息
      </div> -->
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <div
              class="m-t-10 m-b-24 attestation bold"
              style="margin-bottom: 24px"
            >
              认证信息
            </div>
            <a-form-model-item label="姓名" prop="name">
              <a-input
                v-model.trim="form.name"
                :disabled="disabled"
                placeholder="填写姓名"
              />
            </a-form-model-item>
            <a-form-model-item label="身份证号码" prop="identityCard">
              <a-input
                :disabled="disabled"
                v-model.trim="form.identityCard"
                placeholder="填写身份证号码"
              />
            </a-form-model-item>
            <a-form-model-item label="邮箱" prop="Email">
              <a-input
                v-model.trim="form.Email"
                :disabled="disabled"
                placeholder="填写邮箱"
              />
            </a-form-model-item>
            <a-form-model-item label="工作地点" prop="region">
              <a-cascader
                v-model="form.region"
                :disabled="disabled"
                :options="options"
                placeholder="请选择地区"
                @change="onChange"
              />
            </a-form-model-item>
            <a-form-model-item class="address" label="详细地址" prop="address">
              <a-input
                v-model.trim="form.address"
                :disabled="disabled"
                placeholder="填写详细地址"
              />
              <span v-if="!disabled" class="attestation-hint"
                >提示：方便寄送后续相关材料</span
              >
            </a-form-model-item>

            <a-form-model-item label="职业" prop="profession">
              <a-select
                :disabled="disabled"
                v-model="form.profession"
                @change="changePro"
                :placeholder="'请选择职业'"
              >
                <a-select-option
                  :value="item.type"
                  v-for="(item, index) in professionlist"
                  :key="index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item :label="Company" prop="unit" v-show="showMeans">
              <a-input
                v-model.trim="form.unit"
                :disabled="disabled"
                :placeholder="unitPlaceholder"
              />
            </a-form-model-item>
            <a-form-model-item
              label="专业"
              prop="major"
              v-if="form.profession === '6'"
            >
              <a-input
                v-model.trim="form.major"
                :disabled="disabled"
                placeholder="请填写专业名称"
              />
            </a-form-model-item>
            <a-form-model-item
              label="科室"
              prop="administrativeOffice"
              v-show="noWorkId && showMeans"
            >
              <a-cascader
                :disabled="disabled"
                v-model="form.administrativeOffice"
                :default-value="form.administrativeOffice"
                :field-names="{
                  label: 'name',
                  value: 'id',
                  children: 'children'
                }"
                :options="departmentArr"
                placeholder="请选择科室"
                :display-render="displayRender"
                expand-trigger="hover"
                @change="changeDepartment"
              />
            </a-form-model-item>
            <a-form-model-item
              label="职称"
              prop="professionalTitle"
              v-show="noWorkId && showMeans"
            >
              <a-cascader
                :disabled="disabled"
                v-model="form.professionalTitle"
                :display-render="displayRender"
                expand-trigger="hover"
                :field-names="{
                  label: 'name',
                  value: 'id',
                  children: 'children'
                }"
                :options="titleArr"
                placeholder="请选择职称"
                @change="changeTitleName"
              />
            </a-form-model-item>
            <a-form-model-item
              label="是否来自基层"
              class="address"
              prop="levelBasic"
            >
              <a-radio-group name="radioGroup" v-model="form.levelBasic">
                <a-radio :value="0"> 否 </a-radio>
                <a-radio :value="1"> 是 </a-radio>
              </a-radio-group>
              <span class="attestation-hint" style="display: block"
                >提示：县及以下、社区等医疗卫生机构</span
              >
            </a-form-model-item>
            <!-- <div
              class="m-t-10 m-b-10 attestation "
              style="margin-bottom:24px"
              v-if="showMeans"
            >
              <div class="bold">认证资料</div>
              <div class="attestation-hint m-t-10 m-b-10">
                用户消息受法律保护，仅用于认证，其他人不可见
              </div>
            </div> -->
            <!-- <a-form-model-item
              label="执业证编码"
              prop="operationCode"
              v-show="noWorkId && showMeans"
            >
              <a-input
                :disabled="disabled"
                v-model.trim="form.operationCode"
                placeholder="请输入执业证编码"
              />
            </a-form-model-item>
            <a-form-model-item
              label="资格证编码"
              prop="certificationCode"
              v-show="noWorkId && showMeans && form.profession === '1'"
            >
              <a-input
                :disabled="disabled"
                v-model.trim="form.certificationCode"
                placeholder="请输入资格证编码"
              />
            </a-form-model-item> -->
          </a-form-model>
          <!-- <a-row class="attestation m-t-10 m-b-30" style="width: 250px">
            <div class="flex" v-if="showMeans">
              <div class="up-box">
                <a-upload
                  :customRequest="fnUploadRequest3"
                  :before-upload="beforeUpload"
                  list-type="picture-card"
                  :file-list="vcFileList3"
                  @preview="handlePreview3"
                  :remove="remove3"
                >
                  <div v-if="vcFileList3.length < 1">
                    <a-icon type="plus" />
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisible3"
                  :footer="null"
                  @cancel="previewVisible3 = false"
                >
                  <img alt="example" style="width: 100%" :src="previewImage3" />
                </a-modal>
                <div class="up-hint">身份证头像面</div>
              </div>
              <div class="up-box">
                <a-upload
                  :customRequest="fnUploadRequest4"
                  :before-upload="beforeUpload"
                  list-type="picture-card"
                  :file-list="vcFileList4"
                  @preview="handlePreview4"
                  :remove="remove4"
                >
                  <div v-if="vcFileList4.length < 1">
                    <a-icon type="plus" />
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisible4"
                  :footer="null"
                  @cancel="previewVisible4 = false"
                >
                  <img alt="example" style="width: 100%" :src="previewImage4" />
                </a-modal>
                <div class="up-hint">身份证国徽面</div>
              </div>
            </div> -->
          <!-- <div class="flex" v-if="form.profession === '6'"> -->
          <!-- <div class="up-box">
                <a-upload
                  :customRequest="fnUploadRequest6"
                  :before-upload="beforeUpload"
                  list-type="picture-card"
                  :file-list="vcFileList6"
                  @preview="handlePreview6"
                  :remove="remove6"
                >
                  <div v-if="vcFileList6.length < 1">
                    <a-icon type="plus" />
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisible6"
                  :footer="null"
                  @cancel="previewVisible6 = false"
                >
                  <img alt="example" style="width: 100%" :src="previewImage6" />
                </a-modal>
                <div class="up-hint">证件页</div>
              </div> -->
          <!-- 学生证个人信息页是之前的需求注释的 -->
          <!-- <div class="up-box">
                <a-upload
                  :customRequest="fnUploadRequest7"
                  :before-upload="beforeUpload"
                  list-type="picture-card"
                  :file-list="vcFileList7"
                  @preview="handlePreview7"
                  :remove="remove7"
                >
                  <div v-if="vcFileList7.length < 1">
                    <a-icon type="plus" />
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisible7"
                  :footer="null"
                  @cancel="previewVisible7 = false"
                >
                  <img alt="example" style="width: 100%" :src="previewImage7" />
                </a-modal>
                <div class="up-hint">学生证个人信息页</div>
              </div> -->
          <!-- </div> -->
          <!-- <div class="flex m-b-20" v-if="showMeans">
              <div
                class="up-box"
                v-show="
                  form.profession === '7' ||
                    form.profession === '5' ||
                    form.profession === '3'
                "
              >
                <a-upload
                  :customRequest="fnUploadRequest5"
                  :before-upload="beforeUpload"
                  list-type="picture-card"
                  :file-list="vcFileList5"
                  @preview="handlePreview5"
                  :remove="remove5"
                >
                  <div v-if="vcFileList5.length < 1">
                    <a-icon type="plus" />
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisible5"
                  :footer="null"
                  @cancel="previewVisible5 = false"
                >
                  <img alt="example" style="width: 100%" :src="previewImage5" />
                </a-modal>
                <div class="up-hint">工作证/名片/工牌</div>
              </div>
              <div class="up-box" v-show="noWorkId">
                <a-upload
                  :customRequest="fnUploadRequest1"
                  :before-upload="beforeUpload"
                  list-type="picture-card"
                  :file-list="vcFileList1"
                  @preview="handlePreview1"
                  :remove="remove1"
                >
                  <div v-if="vcFileList1.length < 1">
                    <a-icon type="plus" />
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisible1"
                  :footer="null"
                  @cancel="previewVisible1 = false"
                >
                  <img alt="example" style="width: 100%" :src="previewImage1" />
                </a-modal>
                <div class="up-hint">执业证书</div>
              </div>
              <div class="up-box" v-show="noWorkId && form.profession === '1'">
                <a-upload
                  :customRequest="fnUploadRequest2"
                  :before-upload="beforeUpload"
                  list-type="picture-card"
                  :file-list="vcFileList2"
                  @preview="handlePreview2"
                  :remove="remove2"
                >
                  <div v-if="vcFileList2.length < 1">
                    <a-icon type="plus" />
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisible2"
                  :footer="null"
                  @cancel="previewVisible2 = false"
                >
                  <img alt="example" style="width: 100%" :src="previewImage2" />
                </a-modal>
                <div class="up-hint">资格证书</div>
              </div>
            </div>
          </a-row> -->
          <div
            class="attestation"
            style="margintop: 20px; text-align: center"
            v-if="!disabled"
          >
            <a-button type="primary" @click="onSubmit">提交</a-button>
          </div>
          <div
            class="attestation"
            style="margintop: 20px; text-align: center"
            v-if="disabled"
          >
            <a-button type="primary" @click="back">返回</a-button>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import EyeLogo from "@/assets/logo-eye.png";
// import cityData from "@/api/city.json";
import city from "@/mixins/city";
import { setStorageItem, getStorageItem } from "@/utils/storage";
import {
  titleList,
  departmentList,
  studentInfo,
  studentStatus,
  studentDetail
} from "../../api/user";
import oss from "@/utils/aliOss";
const checkIdNumber = (rule, idNumber, callback) => {
  if (
    !/(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/.test(
      idNumber
    )
  ) {
    callback(new Error("请输入正确的身份证号"));
  }
  callback();
};
// const checkNumber = (rule, number, callback) => {
//   if (!/^[0-9]+$/.test(number)) {
//     callback(new Error("请输入正确的证书编号"));
//   }
//   callback();
// };
export default {
  mixins: [city],
  data() {
    return {
      Logo: null,
      title: "明眸学苑",
      headImg: "",
      user: null,
      titleArr: [],
      departmentArr: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 8 },
      options: [],
      areaName: "",
      showMeans: false,
      Company: "单位",
      unitPlaceholder: "请填写单位标准全称",
      cityName: "",
      provinceName: "",
      regionCode: [],
      professionlist: [
        { name: "学生/规培生", type: "6" },
        { name: "基层眼科医生", type: "1" },
        { name: "初级眼保健人员（护士）", type: "2" },
        { name: "视光中心验光师（技师）", type: "3" },
        { name: "学校视觉健康管理人员", type: "4" },
        { name: "相关行政部门管理人员", type: "5" },
        { name: "企业人员", type: "7" }
      ],
      form: {
        region: [],
        Email: "",
        name: "",
        identityCard: "",
        profession: undefined,
        administrativeOffice: [],
        professionalTitle: [],
        unit: undefined,
        operationCode: undefined,
        levelBasic: undefined,
        certificationCode: "",
        address: "",
        major: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        // Email: [
        //   { required: true, message: "请输入邮箱", trigger: "blur" },
        //   {
        //     type: "email",
        //     message: "请输入正确的邮箱地址",
        //     trigger: "blur"
        //   }
        // ],
        levelBasic: [
          { required: true, message: "请选择是否来自基层", trigger: "change" }
        ],
        identityCard: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          {
            validator: checkIdNumber,
            message: "请输入正确的身份证号",
            trigger: "blur"
          }
        ],
        profession: [
          { required: true, message: "请选择地区", trigger: "change" }
        ],
        region: [{ required: true, message: "请选择地区", trigger: "change" }],
        major: [{ required: true, message: "请输入专业名称", trigger: "blur" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ]
      },
      vcFileList1: [], // 职业证书
      previewVisible1: false,
      previewImage1: "",
      vcFileList2: [], // 资格证书
      previewVisible2: false,
      previewImage2: "",
      vcFileList3: [], // 身份证头像面
      previewVisible3: false,
      previewImage3: "",
      vcFileList4: [], // 身份证国徽面
      previewVisible4: false,
      previewImage4: "",
      vcFileList5: [], // 工作证书
      previewVisible5: false,
      previewImage5: "",
      vcFileList6: [], // 学生证书首页
      previewVisible6: false,
      previewImage6: "",
      vcFileList7: [], // 学生证个人信息页
      previewVisible7: false,
      previewImage7: "",
      usertStatus: -1, // 0-未申请; 1-待通过; 2-未通过; 3-已通过
      rejectReason: "",
      noWorkId: false,
      departmentName: "",
      titleName: "",
      disabled: false
    };
  },
  computed: {
    userName() {
      if (this.user) {
        return this.user.name ? this.user.name : this.user.phone;
      }
      return "";
    }
  },
  created() {
    this.Logo = EyeLogo;
    this.options = this.cityList;
    this.user = getStorageItem("USER");
    this.headImg = this.user.imageUrl;
    this.getTitleList();
    this.getDepartmentList();
    this.getStatus();
  },
  methods: {
    ...mapActions({
      logout: "Logout"
    }),
    back() {
      this.$router.back();
    },
    getStatus() {
      studentStatus().then(res => {
        if (res.code === 1) {
          this.usertStatus = res.results.applyStatus;
          this.getUserInfo();
          if (this.usertStatus === 1 || this.usertStatus === 3) {
            this.disabled = true;
          }
          if (this.usertStatus === 0) {
            // 默认眼科
            this.form.administrativeOffice = [5, 38];
            this.changeDepartment(this.form.administrativeOffice);
          }
          if (res.results.applyStatus === 0 && res.results.status === 0) {
            this.$info({
              title: "提示",
              content:
                "系统检测到该登录手机号已注册国培儿科项目学员账号，已为您初始化基本信息"
            });
          }
        }
      });
    },
    getUserInfo() {
      let params = {
        userId: this.user.userId
      };
      studentDetail(params).then(res => {
        if (res.code === 1) {
          let results = res.results;
          this.form.identityCard = results.idNumber;
          this.form.Email = results.email;
          this.areaName = results.area;
          this.cityName = results.city;
          this.provinceName = results.province;
          this.rejectReason = results.rejectReason;
          this.form.name = results.name;
          this.form.address = results.address;
          this.form.levelBasic = results.levelBasic;
          this.form.major = results.major;
          this.form.region = results.regionCode
            ? results.regionCode.split(",")
            : [];
          this.regionCode = results.regionCode
            ? results.regionCode.split(",")
            : "";
          this.form.administrativeOffice = results.departmentCode
            ? results.departmentCode.split("/").map(Number)
            : [];
          this.form.professionalTitle = results.titleCode
            ? results.titleCode.split("/").map(Number)
            : [];
          this.form.profession = String(results.trainer);
          if (
            this.form.profession === "3" ||
            this.form.profession === "5" ||
            this.form.profession === "7" ||
            this.form.profession === "6"
          ) {
            this.noWorkId = false;
          } else {
            this.noWorkId = true;
          }
          if (this.form.profession === "6") {
            this.Company = "学校";
          } else {
            this.Company = "单位";
          }
          this.titleName = results.titleName;
          this.departmentName = results.department;
          this.showMeans = true;
          this.form.unit = results.workplace;
          this.form.operationCode = results.licenseCode;
          this.form.certificationCode = results.qualificationCode;
          if (results.license) {
            this.vcFileList1.push({
              name: "1",
              uid: "-1",
              url: results.license
            });
            this.previewImage1 = results.license;
          }
          if (results.studentUrlFront) {
            this.vcFileList6.push({
              name: "1",
              uid: "-1",
              url: results.studentUrlFront
            });
            this.previewImage6 = results.studentUrlFront;
          }
          if (results.studentDetailUrl) {
            this.vcFileList7.push({
              name: "1",
              uid: "-1",
              url: results.studentDetailUrl
            });
            this.previewImage7 = results.studentDetailUrl;
          }
          if (results.idCard) {
            this.vcFileList5.push({
              name: "1",
              uid: "-1",
              url: results.idCard
            });
            this.previewImage5 = results.idCard;
          }
          if (results.qualification) {
            this.vcFileList2.push({
              name: "1",
              uid: "-1",
              url: results.qualification
            });
            this.previewImage2 = results.qualification;
          }

          if (results.idNumberImgFront) {
            this.vcFileList3.push({
              name: "1",
              uid: "-1",
              url: results.idNumberImgFront
            });
            this.previewImage3 = results.idNumberImgFront;
          }

          if (results.idNumberImgBack) {
            this.vcFileList4.push({
              name: "1",
              uid: "-1",
              url: results.idNumberImgBack
            });
            this.previewImage4 = results.idNumberImgBack;
          }
        }
      });
    },
    _logout() {
      const that = this;
      this.$confirm({
        title: "退出",
        content: "确定退出系统吗？",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          that.logout().then(() => {
            that.$router.push({ name: "Login" });
          });
        }
      });
    },
    displayRender({ labels }) {
      return labels[labels.length - 1];
    },
    handleClick({ key }) {
      switch (key) {
        case "userInfo":
          this.$router.push("/infoguard");
          break;
        case "logout":
          this._logout();
          break;
        default:
      }
    },
    remove1() {
      if (!this.disabled) {
        this.vcFileList1 = [];
        this.previewImage1 = "";
      }
    },
    remove2() {
      if (!this.disabled) {
        this.vcFileList2 = [];
        this.previewImage2 = "";
      }
    },
    remove3() {
      if (!this.disabled) {
        this.vcFileList3 = [];
        this.previewImage3 = "";
      }
    },
    remove4() {
      if (!this.disabled) {
        this.vcFileList4 = [];
        this.previewImage4 = "";
      }
    },
    remove5() {
      if (!this.disabled) {
        this.vcFileList5 = [];
        this.previewImage5 = "";
      }
    },
    remove6() {
      if (!this.disabled) {
        this.vcFileList6 = [];
        this.previewImage6 = "";
      }
    },
    remove7() {
      if (!this.disabled) {
        this.vcFileList7 = [];
        this.previewImage7 = "";
      }
    },
    getTitleList() {
      titleList().then(res => {
        if (res.code === 1) {
          this.titleArr = res.results;
        }
      });
    },
    getDepartmentList() {
      departmentList().then(res => {
        if (res.code === 1) {
          this.departmentArr = res.results;
        }
      });
    },
    async fnUploadRequest1(option) {
      let data = await oss.ossUploadImg(option);
      if (data) {
        this.$message.success({
          content: "上传成功"
        });
        this.previewImage1 =
          "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl;
        this.vcFileList1 = [
          {
            uid: "-1",
            name: data.fileName,
            url: "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl
          }
        ];
      } else {
        this.$message.error({
          content: "上传失败"
        });
      }
    },
    async fnUploadRequest5(option) {
      let data = await oss.ossUploadImg(option);
      if (data) {
        this.$message.success({
          content: "上传成功"
        });
        this.previewImage5 =
          "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl;
        this.vcFileList5 = [
          {
            uid: "-1",
            name: data.fileName,
            url: "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl
          }
        ];
      } else {
        this.$message.error({
          content: "上传失败"
        });
      }
    },
    async fnUploadRequest6(option) {
      let data = await oss.ossUploadImg(option);
      if (data) {
        this.$message.success({
          content: "上传成功"
        });
        this.previewImage6 =
          "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl;
        this.vcFileList6 = [
          {
            uid: "-1",
            name: data.fileName,
            url: "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl
          }
        ];
      } else {
        this.$message.error({
          content: "上传失败"
        });
      }
    },
    async fnUploadRequest7(option) {
      let data = await oss.ossUploadImg(option);
      if (data) {
        this.$message.success({
          content: "上传成功"
        });
        this.previewImage7 =
          "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl;
        this.vcFileList7 = [
          {
            uid: "-1",
            name: data.fileName,
            url: "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl
          }
        ];
      } else {
        this.$message.error({
          content: "上传失败"
        });
      }
    },
    async fnUploadRequest2(option) {
      let data = await oss.ossUploadImg(option);
      if (data) {
        this.$message.success({
          content: "上传成功"
        });
        this.previewImage2 =
          "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl;
        this.vcFileList2 = [
          {
            uid: "-1",
            name: data.fileName,
            url: "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl
          }
        ];
      } else {
        this.$message.error({
          content: "上传失败"
        });
      }
    },
    async fnUploadRequest3(option) {
      let data = await oss.ossUploadImg(option);
      if (data) {
        this.$message.success({
          content: "上传成功"
        });
        this.previewImage3 =
          "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl;
        this.vcFileList3 = [
          {
            uid: "-1",
            name: data.fileName,
            url: "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl
          }
        ];
      } else {
        this.$message.error({
          content: "上传失败"
        });
      }
    },
    async fnUploadRequest4(option) {
      let data = await oss.ossUploadImg(option);
      if (data) {
        this.$message.success({
          content: "上传成功"
        });
        this.previewImage4 =
          "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl;
        this.vcFileList4 = [
          {
            uid: "-1",
            name: data.fileName,
            url: "https://eye-lib.oss-cn-shanghai.aliyuncs.com/" + data.fileUrl
          }
        ];
      } else {
        this.$message.error({
          content: "上传失败"
        });
      }
    },
    beforeUpload(file) {
      if (
        file.type !== "image/png" &&
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg"
      ) {
        this.$message.error({
          content: "请上传png或jpg格式的图片"
        });
        return false;
      }
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error({
          content: "上传图片大小限制2MB，请重新上传"
        });
        return false;
      }
    },
    changePro(value) {
      this.showMeans = true;
      if (value === "1") {
        // 基层眼科
        this.form.professionalTitle = [1, 9];
        this.changeTitleName(this.form.professionalTitle);
        this.form.administrativeOffice = [5, 38];
        this.changeDepartment(this.form.administrativeOffice);
      } else if (value === "2") {
        // 护士
        this.form.professionalTitle = [2, 14];
        this.changeTitleName(this.form.professionalTitle);
        this.form.administrativeOffice = [5, 38];
        this.changeDepartment(this.form.administrativeOffice);
      } else if (value == "4") {
        this.form.professionalTitle = [];
        this.titleName = "";
        this.form.administrativeOffice = [5, 38];
        this.changeDepartment(this.form.administrativeOffice);
      } else {
        this.form.professionalTitle = [];
        this.form.administrativeOffice = [];
        this.titleName = "";
        this.departmentName = "";
      }
      if (value === "6") {
        this.Company = "学校";
        this.unitPlaceholder = "请输入学校标准全称";
        this.$set(this.rules, "unit", [
          { required: true, message: `请输入学校标准全称`, trigger: "blur" }
        ]);
      } else {
        this.$set(this.rules, "unit", [
          { required: true, message: `请填写单位标准全称`, trigger: "blur" }
        ]);
        this.Company = "单位";
        this.unitPlaceholder = "请填写单位标准全称";
      }
      if (value === "3" || value === "5" || value === "7" || value === "6") {
        this.noWorkId = false;
        this.$set(this.rules, "operationCode", []);
        this.$set(this.rules, "certificationCode", []);
        this.$set(this.rules, "administrativeOffice", []);
        this.$set(this.rules, "professionalTitle", []);
      } else {
        // 只有医生护士进行校验
        this.noWorkId = true;
        // this.$set(this.rules, "operationCode", [
        //   { required: true, message: "填写执业证编码", trigger: "blur" },
        //   {
        //     validator: checkNumber,
        //     message: "请输入正确证书编码",
        //     trigger: "blur"
        //   }
        // ]);
        // this.$set(this.rules, "certificationCode", [
        //   { required: true, message: "填写资格证编码", trigger: "blur" },
        //   {
        //     validator: checkNumber,
        //     message: "请输入正确证书编码",
        //     trigger: "blur"
        //   }
        // ]);
        this.$set(this.rules, "administrativeOffice", [
          { required: true, message: "请选择科室", trigger: "change" }
        ]);
        this.$set(this.rules, "professionalTitle", [
          { required: true, message: "请选择职称", trigger: "change" }
        ]);
      }
    },
    changeDepartment(value) {
      let stairDepartment = value[0];
      let secondLevel = value[1];
      let secondLevelArr = [];
      for (let i = 0; i < this.departmentArr.length; i++) {
        if (this.departmentArr[i].id === stairDepartment) {
          secondLevelArr = this.departmentArr[i].children;
          break;
        }
      }
      for (let i = 0; i < secondLevelArr.length; i++) {
        if (secondLevelArr[i].id === secondLevel) {
          this.departmentName = secondLevelArr[i].name;
          break;
        }
      }
    },
    changeTitleName(value) {
      let stairTitle = value[0];
      let secondTitle = value[1];
      let secondLevelArr = [];
      for (let i = 0; i < this.titleArr.length; i++) {
        if (this.titleArr[i].id === stairTitle) {
          secondLevelArr = this.titleArr[i].children;
          break;
        }
      }
      for (let i = 0; i < secondLevelArr.length; i++) {
        if (secondLevelArr[i].id === secondTitle) {
          this.titleName = secondLevelArr[i].name;
          break;
        }
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          console.log("success");
          this.saveInfo();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    saveInfo() {
      // if (
      //   this.form.profession === "3" ||
      //   this.form.profession === "5" ||
      //   this.form.profession === "7"
      // ) {
      //   if (!this.previewImage5) {
      //     this.$message.error({
      //       content: "请上传工作证书"
      //     });
      //     return;
      //   }
      // } else {
      //   if (
      //     this.form.profession === "1" ||
      //     this.form.profession === "2" ||
      //     this.form.profession === "4"
      //   ) {
      //     if (!this.previewImage1) {
      //       this.$message.error({
      //         content: "请上传职业证书"
      //       });
      //       return;
      //     }
      //     if (!this.previewImage2) {
      //       this.$message.error({
      //         content: "请上传资格证书"
      //       });
      //       return;
      //     }
      //   } else {
      //     if (!this.previewImage6) {
      //       this.$message.error({
      //         content: "请上传学生证封面"
      //       });
      //       return;
      //     }
      //     if (!this.previewImage7) {
      //       this.$message.error({
      //         content: "请上传学生证个人信息页"
      //       });
      //       return;
      //     }
      //   }
      // }
      // if (!this.previewImage4) {
      //   this.$message.error({
      //     content: "请上传身份证国徽面"
      //   });
      //   return;
      // }
      // if (!this.previewImage3) {
      //   this.$message.error({
      //     content: "请上传身份证头像面"
      //   });
      //   return;
      // }

      let params = {
        department: this.departmentName, // 科室
        departmentCode: this.form.administrativeOffice.join("/"),
        idNumberImgBack: this.previewImage4, // 身份证反面照
        idNumberImgFront: this.previewImage3, // 身份证正面照
        studentUrlFront: this.previewImage6, // 学生证书首页
        studentDetailUrl: this.previewImage7, // 学生证个人信息页
        major: this.form.major, // 学生专业
        license: this.previewImage1, // 职业证书
        licenseCode: this.form.operationCode
          ? this.form.operationCode.replace(/\s*/g, "")
          : "", //职业证书编号
        name: this.form.name.replace(/\s*/g, ""), //姓名
        qualification: this.previewImage2, //资格证书
        titleName: this.titleName,
        titleCode: this.form.professionalTitle.join("/"), //职称id
        userId: this.user.userId,
        qualificationCode: this.form.certificationCode
          ? this.form.certificationCode.replace(/\s*/g, "")
          : "", // 资格证书编码
        workplace: this.form.unit.replace(/\s*/g, ""), //工作单位
        area: this.areaName,
        city: this.cityName,
        province: this.provinceName,
        regionCode: this.regionCode.join(","),
        email: this.form.Email ? this.form.Email.replace(/\s*/g, "") : "",
        idCard: this.previewImage5,
        idNumber: this.form.identityCard,
        trainer: this.form.profession,
        address: this.form.address,
        levelBasic: this.form.levelBasic
      };
      studentInfo(params).then(res => {
        if (res.code === 1) {
          this.$message.success({
            content: "提交成功"
          });
          let user = getStorageItem("USER");
          user.name = this.form.name;
          setStorageItem("USER", user);
          // this.$router.back();
          //dream 新用户跳转课程页，需要系统直接弹窗显示付费
          this.$router.push({
            name: "StudentCourseList",
            query: { type: "dream" }
          });
        }
      });
    },
    async handlePreview1(img) {
      this.previewImage1 = img.url;
      this.previewVisible1 = true;
    },
    async handlePreview5(img) {
      this.previewImage5 = img.url;
      this.previewVisible5 = true;
    },
    async handlePreview6(img) {
      this.previewImage6 = img.url;
      this.previewVisible6 = true;
    },
    async handlePreview7(img) {
      this.previewImage7 = img.url;
      this.previewVisible7 = true;
    },
    async handlePreview2(img) {
      this.previewVisible2 = true;
      this.previewImage2 = img.url;
    },
    async handlePreview3(img) {
      this.previewImage3 = img.url;
      this.previewVisible3 = true;
    },
    async handlePreview4(img) {
      this.previewImage4 = img.url;
      this.previewVisible4 = true;
    },
    onChange(value) {
      this.regionCode = value;
      let provinceCode = value[0];
      let cityCode = value[1];
      let areaCode = value[2];
      let cityArr = [];
      let areaArr = [];
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].value === provinceCode) {
          this.provinceName = this.options[i].label;
          cityArr = this.options[i].children;
          break;
        }
      }
      for (let i = 0; i < cityArr.length; i++) {
        if (cityArr[i].value === cityCode) {
          this.cityName = cityArr[i].label;
          areaArr = cityArr[i].children;
          break;
        }
      }
      for (let i = 0; i < areaArr.length; i++) {
        if (areaArr[i].value === areaCode) {
          this.areaName = areaArr[i].label;
          break;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.apply-wrapper {
  height: 100%;
  background: #f5f5fc;
  .header-wrapper {
    background: rgba(255, 255, 255, 1);
  }
  .header-content {
    height: 80px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: @primary-color;
    }
    .name {
      max-width: 60px;
      color: rgba(0, 0, 0, 0.65);
      margin-left: 8px;
    }
    .user-info {
      height: 100%;
      .search-wrap {
        width: 206px;
      }
      .bell {
        padding: 0 8px;
        font-size: 20px;
        transition: all 0.3s;
        &:hover {
          color: @primary-color;
        }
      }
    }
  }
  .auto-box {
    padding: 20px;
  }
  .attestation {
    max-width: 560px;
    margin: 0 auto;
    font-size: 18px;

    .up-box {
      margin-right: 20px;
      .up-hint {
        text-align: center;
        font-size: 12px;
        color: #969799;
      }
    }
  }
  .attestation-hint {
    font-size: 12px;
    color: #969799;
  }
  .flex-direction {
    display: flex;
    flex-direction: column;
  }
  .keshi {
    display: flex;
  }
  /deep/ .address .ant-form-item-label {
    line-height: 26px !important;
  }
  /deep/ .address .ant-col .ant-form-item-control {
    line-height: 26px !important;
  }
}
</style>
